import { feathers } from '@feathersjs/feathers';
import * as GatewayParser from './gateway/parser';
import * as LocalCache from './utils/LocalCache';
export let globalApplication = undefined;
export function createApplication() {
    const app = feathers();
    if (!globalApplication) {
        globalApplication = app;
    }
    app.configure(LocalCache.init);
    app.configure(GatewayParser.init);
    return app;
}
//# sourceMappingURL=application.js.map